exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ludo-game-rule-container .content {\n  width: 100%;\n  box-sizing: border-box;\n  text-align: center;\n}\n.ludo-game-rule-container .content .rule-box {\n  padding: 0 0.4rem;\n  text-align: start;\n}\n.ludo-game-rule-container .content .rule-box .rule-title {\n  font-size: 0.3rem;\n  color: #fff;\n  font-weight: bold;\n}\n.ludo-game-rule-container .content .rule-box span {\n  color: #60CEB6;\n  font-weight: 500;\n  font-size: 0.23rem;\n}\n.ludo-game-rule-container .content .rule-box .white {\n  color: #fff;\n  font-weight: bold;\n}\n.ludo-game-rule-container .content .pic {\n  display: inline-block;\n  margin: 0.15rem auto;\n  width: 5.5rem;\n  height: 2.7rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/ludo/gamerule/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/ludo/gamerule/index.less
// module chunks = 0